
export class FormTemplateInstancesButtonInfo {
    public buttonDisplayName: string;
    public alias: string;
    public enableButton: boolean;

    public constructor(buttonDisplayName: string, enableButton: boolean = true, alias: string = null) {
        this.buttonDisplayName = buttonDisplayName;
        this.enableButton = enableButton;
        this.alias = alias;
    }
}
